export const KizFilesGridPluginSettings: IPluginSettings = {
    name: 'Конфигурация службы КИЗ',
    mnemocode: 'kiz_files_plugin',
    permission: 'Kiz',
    columns: [
    ]
}
